module.exports = __webpack_public_path__ + "img/title_zhCn@3x.dfbbcf89.png";